import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

export const Close = styled('button')(
  ({ theme }: Theme) => css`
    position: absolute;
    right: 12px;
    top: 12px;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    font-size: 22px;
    cursor: pointer;
    color: ${theme.colors.n600};

    &:hover {
      color: ${theme.colors.n900};
    }
  `
)

export const Title = styled('h3')(
  ({ theme }: Theme) => css`
    margin: 0 36px 12px 4px;
    font-size: 22px;
    font-weight: 800;
    color: ${theme.colors.n900};
    line-height: 1.25;
  `
)

export const Text = styled('p')(
  ({ theme }: Theme) => css`
    margin: 10px 6px;
    color: ${theme.colors.n600};
    font-size: 14px;
    line-height: 1.5;
  `
)
